import React, { useContext, useState } from "react";
import pero from "../../assets/images/expertise1.svg";
import tanks from "../../assets/images/expertise2.svg";
import lone from "../../assets/images/expertise3.svg";
import softside from "../../assets/images/expertise4.svg";
import aes from "../../assets/images/clientLight4.webp";
import viti from "../../assets/images/expertise6.svg";
import { Link } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
// import bell from "../../assets/images/bell.png"

type ExpertiseType = {
  heading?: string;
  des: string;
  logo: string;
  alt: string;
  link: string;
};

const experties: { [key: string]: ExpertiseType } = {
  Automotive: {
    heading: "Automotive",
    des: "We understand the automotive world moves fast. Our experience helps automotive brands build deeper customer loyalty and accelerate real business growth.",
    logo: viti,
    alt: "vitti",
    link: "https://vittilog.com/",
  },
  Finance: {
    heading: "",
    des: "",
    logo: "",
    alt: "",
    link: "",
  },
  Media_and_Entertainment: {
    heading: "",
    des: "",
    logo: "",
    alt: "",
    link: "",
  },
  Public_Sector: {
    heading: "",
    des: "",
    logo: "",
    alt: "",
    link: "",
  },
  Sports: {
    heading: "",
    des: "",
    logo: "",
    alt: "",
    link: "",
  },
  Blockchain_and_crypto: {
    heading: "",
    des: "",
    logo: "",
    alt: "",
    link: "",
  },
  Hospitality: {
    heading: "Hospitality",
    des: "Understanding what guests value most, we help hospitality brands create memorable journeys and build lasting guest relationships online.",
    logo: lone,
    alt: "lone stars cent",
    link: "https://lonestarscent.com/",
  },
  Information_Technology: {
    heading: "",
    des: "",
    logo: "",
    alt: "",
    link: "",
  },
  Management_Consultancy: {
    heading: "Management Consultancy",
    des: "From refining your messaging to building lead pipelines, we help management consultancies grow with measurable marketing actions.",
    logo: aes,
    alt: "aes",
    link: "https://www.aesrecruitment.com/",
  },
  Oil_and_Energy: {
    heading: "Oil and Energy",
    des: "We’ve partnered with oil and energy companies to shape narratives that reflect their impact, innovation, and industry leadership",
    logo: pero,
    alt: "pero",
    link: "https://powersquared.tech/",
  },
  Retail: {
    heading: "",
    des: "",
    logo: "",
    alt: "",
    link: "",
  },
  Construction: {
    heading: "Construction",
    des: "From showcasing your projects to attracting high-value clients, we help construction brands grow with marketing that delivers results.",
    logo: tanks,
    alt: "tanks",
    link: "https://www.tanksandcovers.com/",
  },
  Ecommerce: {
    heading: "Ecommerce",
    des: "From first visit to final purchase, we help e-commerce brands create journeys customers actually love and remember.",
    logo: softside,
    alt: "softside",
    link: "https://www.softsidebyhunt.com/",
  },
  Real_Estate: {
    heading: "",
    des: "",
    logo: "",
    alt: "",
    link: "",
  },
};
const NewExpertise: React.FC = () => {
  const [selectedIndustry, setSelectedIndustry] =
    useState<string>("Automotive");
  const dataContext = useContext(AuthContext);

  const handleIndustryClick = (industry: string) => {
    if (experties[industry].heading && experties[industry].des) {
      setSelectedIndustry(industry);
    }
  };

  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <section
      className={`${
        theme === "dark" ? "bg-white" : "bg-black"
      } transition-all duration-500`}
    >
      <div className="max-w-screen-2xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row gap-6 justify-between z-10 relative">
          {/* Industries List */}
          <div className="w-full lg:w-[50%]">
            <h2
              className={`${
                theme === "dark" ? "text-black" : "text-white"
              } text-center sm:text-left bricolage-grotesque-bold text-[32px] sm:text-6xl mb-3 sm:mb-6 transition-all w-full duration-500`}
            >
              Expertise
            </h2>
            <h2
              className={`${
                theme === "dark" ? "text-black" : "text-white"
              } transition-all duration-500 text-lg font-semibold font-gtAmerica mb-4 text-center sm:text-left`}
            >
              Industries we serve
            </h2>
            <ul className="flex items-center sm:grid sm:grid-cols-3 space-x-3 lg:space-x-0 space-y-2 overflow-x-scroll no-scrollbar">
              {Object.keys(experties).map((industry, index) => {
                const isAvailable =
                  experties[industry].heading && experties[industry].des;
                return (
                  <div className="flex group " key={index}>
                    <div
                      className={`p-[1px] group-hover:custom-gradient2 transition-all duration-500 rounded-full self-start ${
                        selectedIndustry === industry
                          ? "custom-gradient2"
                          : "bg-transparent"
                      } `}
                    >
                      <button
                        onClick={() => handleIndustryClick(industry)}
                        className={`w-36 sm:w-full flex justify-center text-left text-sm font-montserrat font-semibold  ${
                          theme === "dark"
                            ? `bg-white ${
                                selectedIndustry === industry
                                  ? ""
                                  : isAvailable
                                  ? ""
                                  : "text-gray-400 cursor-not-allowed"
                              }`
                            : `bg-[#141414]  ${
                                selectedIndustry === industry
                                  ? "text-white"
                                  : isAvailable
                                  ? "text-white bg-transparent group-hover:bg-[#141414]"
                                  : "text-gray-400 cursor-not-allowed bg-transparent group-hover:bg-[#141414]"
                              }`
                        } py-2 px-4 rounded-full text-center`}
                        disabled={!isAvailable}
                      >
                          {industry.replace(/_/g, " ")}{" "}
                          {/* Replace underscores with spaces */}
                      </button>
                    </div>
                  </div>
                );
              })}
            </ul>
          </div>
              {/* <img src={bell} alt="" className="absolute -top-20 md:left-[200px] h-40 md:h-auto" /> */}
          {/* Purple Content Box */}
          <div
            className={`${
              theme === "dark"
                ? " bg-primary border border-primary"
                : "bg-[#2A2A2A] border border-white/30"
            } w-full lg:w-[40%] text-white px-4 sm:px-12 py-10 rounded-lg shadow-lg transition-all duration-500 relative overflow-hidden`}
          >
            {experties[selectedIndustry].heading ? (
              <div className="flex flex-col justify-between h-full">
                <h3 className="text-xl font-semibold mb-4 bricolage-grotesque-semibold text-center sm:text-left">
                  {experties[selectedIndustry].heading}
                </h3>
                <p className="mt-4 font-gtAmerica text-xl sm:text-2xl font-medium mb-4 text-center sm:text-left">
                  {experties[selectedIndustry].des}
                </p>
                <div className="flex gap-4 sm:gap-0 sm:flex-row justify-between items-center mt-4">
                  <a
                    href={experties[selectedIndustry].link}
                    className=" cursor-pointer mb-4 sm:mb-0  w-[40%] relative z-30"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={experties[selectedIndustry].logo}
                      alt={experties[selectedIndustry].alt}
                      className="hover:scale-110 transition-all duration-500"
                    />
                  </a>
                  <div className="hover:!shadow-[0px_0px_40px_#8d19da] rounded-full transition-all duration-500">
                    <Link
                      to="/contact"
                      className={`${
                        theme === "dark"
                          ? "border border-secondary bg-white hover:bg-secondary hover:text-white hover:border-white hover:shadow-[0px_0px_20px_#F20B97]"
                          : "!bg-black text-white !shadow-[inset_0px_0px_10px_#F20B97] shadow-secondary border border-secondary"
                      } text-sm text-black sm:text-[16px] transition-all duration-500 relative z-50 px-6 sm:px-8 py-2 sm:py-3 text-[16px] font-medium rounded-full`}
                    >
                      Let's Talk
                    </Link>
                  </div>
                </div>
              </div>
            ) : (
              <p>No information available for this industry.</p>
            )}

            <svg
              width="1444"
              height="1292"
              viewBox="0 0 1444 1292"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="absolute -top-[250px] left-0 w-full opacity-40"
            >
              <g filter="url(#filter0_f_3562_1617)">
                <ellipse cx="722" cy="646" rx="643" ry="393" fill="#8D19DA" />
              </g>
              <defs>
                <filter
                  id="filter0_f_3562_1617"
                  x="-173.6"
                  y="0.399994"
                  width="1791.2"
                  height="1291.2"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                  />
                  <feGaussianBlur
                    stdDeviation="126.3"
                    result="effect1_foregroundBlur_3562_1617"
                  />
                </filter>
              </defs>
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewExpertise;
